export const USER_PREFERENCE_KEYS = [
  'notifEmail',
  'notifAdminEmail',
  'filterCompaniesList',
  'filterProductsList',
  'onboardColumnCompaniesList',
  'onboardColumnProductsList',
  'savedTablePreferences',
  'userLanguage',
  'savedAnalyticsFilterPreferences',
  'passkeyPrompt',
] as const;

/** Only retraced staff may set this preference key — enforced IAM-natively in
 *  `UserPreferencesService.applyPreferencePatch`, not via a role-string list. */
export const ADMIN_ONLY_PREFERENCE_KEY = 'notifAdminEmail';

/**
 * The preferences whose changes are recorded in `entity_history`
 * (`USER_PREFERENCE`): the settings someone would ask "who changed this?"
 * about. The other keys are UI state, rewritten on every column move or filter
 * change, and are not recorded.
 */
export const USER_PREFERENCE_HISTORY_KEYS: readonly string[] = [
  'notifEmail',
  'notifAdminEmail',
  'userLanguage',
];
